<template lang="pug">
el-dialog.modal-cadastrar-sucursal(
    :title='$t("mensagens.usuarios.modalSucursal")',
    :visible.sync='dialogVisible',
    width='500px',
    :before-close='fecharModal',
    :close-on-click-modal='false'
)
    el-form(:model='novaSucursal')
        el-form-item
            .label(slot='label')
                span {{ $t('mensagens.usuarios.tabela.nome') }}
                span.erro(v-if='$v.novaSucursal.nome.$invalid') *
            el-input(
                v-model='novaSucursal.nome',
                maxlength='100',
                :placeholder='$t("mensagens.comuns.placeholder")'
            )

        el-form-item
            .label(slot='label')
                span CUIT Sucursal
                span.erro(v-if='$v.novaSucursal.cuit.$invalid') *
            el-input(
                v-model='novaSucursal.cuit',
                :placeholder='$t("mensagens.comuns.placeholder")',
                maxlength='14',
                @input='formatarCuitInput'
            )

    footer(slot='footer')
        el-button(size='mini', @click='fecharModal') {{ $t('mensagens.comuns.cancelar') }}
        el-button(
            :disabled='$v.novaSucursal.$invalid',
            size='mini',
            type='primary',
            @click='cadastrarSucursal'
        ) {{ $t('mensagens.comuns.cadastrar') }}
</template>

<script>
import { required, helpers } from 'vuelidate/lib/validators';
import SucursaleService from '@/services/SucursaleService';

const cuitValido = helpers.withParams({ type: 'cuitValido' }, value => {
    if (!value) return false;

    const numeroCuit = value.replace(/\D/g, '');
    if (numeroCuit.length !== 11) return false;

    const multiplicadores = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let soma = 0;

    for (let i = 0; i < 10; i++) {
        soma += parseInt(numeroCuit[i]) * multiplicadores[i];
    }

    const resto = soma % 11;
    let digitoVerificador;

    if (resto === 0) digitoVerificador = 0;
    else if (resto === 1) digitoVerificador = 9;
    else digitoVerificador = 11 - resto;

    return parseInt(numeroCuit[10]) === digitoVerificador;
});

export default {
    name: 'SucursaleModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            novaSucursal: {
                nome: '',
                cuit: ''
            }
        };
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit('update:visible', value);
            }
        }
    },
    validations: {
        novaSucursal: {
            nome: { required },
            cuit: { required, cuitValido }
        }
    },
    methods: {
        formatarCuitInput(value) {
            const numeros = value.replace(/\D/g, '');

            let formatado = '';
            if (numeros.length <= 2) {
                formatado = numeros;
            } else if (numeros.length <= 10) {
                formatado = `${numeros.slice(0, 2)}-${numeros.slice(2)}`;
            } else {
                formatado = `${numeros.slice(0, 2)}-${numeros.slice(
                    2,
                    10
                )}-${numeros.slice(10)}`;
            }

            this.novaSucursal.cuit = formatado;
        },

        limparFormulario() {
            this.novaSucursal = {
                nome: '',
                cuit: ''
            };
        },

        fecharModal() {
            this.limparFormulario();
            this.$emit('fechar');
        },

        async cadastrarSucursal() {
            try {
                const cuitSemFormatacao = this.novaSucursal.cuit.replace(
                    /\D/g,
                    ''
                );

                const dadosSucursal = {
                    nome: this.novaSucursal.nome,
                    cuit: cuitSemFormatacao
                };

                await SucursaleService.cadastrarSucursal(dadosSucursal);

                this.fecharModal();
                this.$emit('listaSucursais');
            } catch (error) {
                this.$notify.error({
                    message:
                        this.$t('mensagens.sucursales.erroCadastrar') +
                        `: ${error.message}`
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-cadastrar-sucursal {
    footer {
        display: flex;
        justify-content: space-between;

        .el-button {
            width: 80px;
        }
    }

    .label {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .erro {
        color: red;
        font-size: 10px;
        display: block;
        line-height: 1.5;
    }

    .el-form-item__label {
        margin-bottom: -10px;
    }
}

.el-select {
    width: 460px;
}
</style>
